var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"section6"}},[_c('div',{staticClass:"s6_container"},[_c('img',{attrs:{"src":require("../../assets/images/home/section6/s6_img.png")}}),_c('img',{attrs:{"src":require("../../assets/images/home/section6/s6_img2.png")}})])])
}]

export { render, staticRenderFns }